import { Component, OnInit, ErrorHandler } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { StepRedoService } from './step-redo.service';
import { SelectableQuadrant } from '../carrier/selectable-Quadrant';
import { RedoProcessingRequest } from './redo-processing-request';
import { SelectableLab } from '../carrier/selectable-lab';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'app-step-redo',
  templateUrl: './step-redo.component.html',
  styleUrls: ['./step-redo.component.css']
})
export class StepRedoComponent implements OnInit {
  quadrants:SelectableQuadrant[];
  selectedQuadrant:SelectableQuadrant;
  redoSequenceForm: FormGroup;
  redoSequencingBy:string;
  redoContainerBarcode:string;
  selectedLab: SelectableLab;
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked:boolean;

  constructor(private formBuilder: FormBuilder,private messagesService: MessagesService,private stepRedoService: StepRedoService) { 
    this.quadrants=[{label:'A1',value:'A1'},
    {label:'A2',value:'A2'},
    {label:'B1',value:'B1'},
    {label:'B2',value:'B2'} 
    ];

    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    
  }

  ngOnInit() {

    this.redoSequenceForm = this.formBuilder.group({
      'redoSequencingBy': new FormControl('', Validators.required),
      'redoContainerBarcode': new FormControl('', Validators.required),
      'selectedQuadrant': new FormControl('', null)

       });
       
  }

  /**
   * @function
   * @description: This method is to get the focus to Carrier Barcode Field
   */
  focusContainerbarcode() {
    document.getElementById('redoContainerBarcode').focus();
  }

  checkSelectedItem(item:SelectableQuadrant){
    console.log(item.value);
  }
  
  onSubmit(value: string) {
    
      //this.redoSequenceForm.reset();
      //document.getElementById('redoneSequencingBy').focus();
    }

    performRedoProcess(redoneSequencingBy,redoContainerBarcode,){
      this.blocked = true;
      let status = new RedoProcessingRequest;
      status.redoInitiatedBy = this.redoSequencingBy;
      status.containerBarcode = this.redoContainerBarcode.trim();
      if (this.selectedQuadrant != null) {
        status.quadrant = this.selectedQuadrant.value;
      }
      status.lab = this.selectedLab.lab;
      
    this.stepRedoService.initiateRedoProcess(status).subscribe(
      result => {
        this.blocked = false;
        if(result.bbApiWarning){
          this.messagesService.addWarningMessage({ severity: 'warn', summary: result.bbApiWarning.title, detail: result.bbApiWarning.message });
          if(result.bbApiWarning.allowToContinue)
          {
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Redo Completed', detail: 'Redo sequencing completed' });
          }
        }
        else{
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Redo Completed', detail: 'Redo sequencing completed' });
        }
        this.blocked = false
      },
      error => {
        this.blocked = false;
        this.messagesService.addErrorMessage({ severity: 'error', summary: 'Redo Failed', detail: 'Redo sequencing failed' });
        this.blocked = false
      }
    );
  }
  

}
